// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderSpinner_loader__1tDNI"};